/**
 * Инициалы для аватара-заглушки.
 *
 * Фотографий у мастеров и заведений в схеме пока нет — владельцы будут ставить их сами,
 * когда появится загрузка. До тех пор место под фото занято инициалами, а не пустым
 * кружком: пустой кружок читается как «картинка не загрузилась», то есть как поломка,
 * а инициалы выглядят намеренно. Когда поле фото появится, меняется только компонент.
 *
 * Берутся первые буквы первых двух слов: «Иван Петров» → «ИП», «Barber House» → «BH».
 * Одно слово — одна буква, а не две первые: «Ак» от «Акбар» выглядит обрезком имени,
 * тогда как «А» выглядит решением.
 *
 * Строка без букв (пробелы, эмодзи, пустое имя) даёт пустой результат, и компонент
 * рисует иконку человека. Возвращать «?» нельзя: вопросительный знак на месте имени
 * читается как ошибка данных, хотя имени просто нет.
 */
export function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const letters = words
    .slice(0, 2)
    // Первый СИМВОЛ слова может не быть буквой — «„Имидж“» начинается с кавычки.
    // Берётся первая буква или цифра, иначе слово пропускается целиком.
    .map((word) => [...word].find((char) => /\p{L}|\p{N}/u.test(char)))
    .filter((char): char is string => char !== undefined);

  return letters.join('').toLocaleUpperCase();
}
